import CONFIG from '~/config'

export const setHideActivateBillPayCardModalItem = () => localStorage.setItem(CONFIG.COOKIE_HIDE_ACTIVATE_BILL_PAY_CARD_MODAL, true)
export const removeActivateBillPayCardModalItem = () => localStorage.removeItem(CONFIG.COOKIE_HIDE_ACTIVATE_BILL_PAY_CARD_MODAL)
export const getActivateBillPayCardModalItem = () => !!localStorage.getItem(CONFIG.COOKIE_HIDE_ACTIVATE_BILL_PAY_CARD_MODAL)
